import QRCode from 'qrcodejs2-fix'

/**
 * 将链接渲染到指定的 DOM 容器上
 * @param el 容器元素
 * @param url 要生成二维码的链接
 * @param size 尺寸，默认 160
 */
export function renderQrCode(el: HTMLElement, url: string, size = 160): void {
  el.innerHTML = ''
  new QRCode(el, {
    text: url,
    width: size,
    height: size,
    colorDark: '#000000',
    colorLight: '#ffffff'
  })
}
